/**
 * Roles that are real but are not this trimester's work.
 *
 * Two kinds, and they get the same shape because they mean the same thing to a
 * reader: still on the board, folded away by default. Cancelled seats are part
 * of what happened to the round and hiding them entirely makes a plan that was
 * cut look like a plan that was never made; a backlog seat starting after the
 * target window is approved demand that simply is not being worked yet.
 *
 * Folding rather than filtering is the point — the count is on the closed row,
 * so the reader can see there is something there without it pushing the roles
 * being worked off the first screen.
 */
import type { BoardRole, DemandMonth } from '../../../../types/taDemand';
import type { Track } from '../../demand/demandModel';
import { indentPx } from '../../demand/demandGrid';
import { HiringRow } from './HiringRow';

export function FoldedRoles({
  roles,
  tracks,
  months,
  currentMonth,
  depth,
  label,
  open,
  onToggle,
  cancelled = false,
}: {
  roles: BoardRole[];
  tracks: Track[];
  months: DemandMonth[];
  currentMonth: string;
  depth: number;
  label: (n: number) => string;
  open: boolean;
  onToggle: () => void;
  cancelled?: boolean;
}) {
  if (!roles.length) return null;
  return (
    <>
      <div className="grid border-b border-gray-100" style={{ gridTemplateColumns: 'var(--demand-tmpl)' }}>
        <div
          className="sticky left-0 z-[2] flex min-w-0 items-center border-r border-gray-200 bg-white pr-2"
          style={{ paddingLeft: indentPx(depth) }}
        >
          <button
            type="button"
            onClick={onToggle}
            className={`min-w-0 truncate py-1 text-left text-[12px] ${
              cancelled ? 'text-rose-400 hover:text-rose-600' : 'text-gray-400 hover:text-gray-600'
            }`}
          >
            {open ? '▾' : '▸'} {label(roles.length)}
          </button>
        </div>
      </div>
      {open &&
        roles.map((r) => (
          <HiringRow
            key={r.id}
            role={r}
            tracks={tracks}
            months={months}
            currentMonth={currentMonth}
            depth={depth + 1}
            cancelled={cancelled}
          />
        ))}
    </>
  );
}
